//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Store from '../../store/store'
import HeaderSteps from './headersteps'
import Upload from './steps/upload'
import Assignment from './steps/assignment'
import DownloadXml from './steps/downloadxml'
import api from '../../source/api'
import BaseComponent from '../base'
import Rules from './rules'
import {Link} from "react-router-dom";
import i18 from "../../i18";

class Supplier extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            editrules: false,
            hidemenu: false,
            company_id: props.location.match.params.id,
            currentStep: 1,
            userconfigs: {},
            company: [],
            invoices: [],
            supplierRules: [],
            vatCollectorCodes: [],
            onlineszamlaToken: false,
        };
        this.store = Store;
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            company: nextProps.company,
        });
    };


    hideStepsMenu = () => {
        this.setState({
            hidemenu: true
        });
    };

    componentDidMount = () => {
        window.scrollTo(0, 0);

        document.body.classList.toggle('loading-body', true);

        api.get({url: 'supplier/init?company_id=' + this.state.company_id}, true).then((response) => {
            this.setState({
                company: response.data.company,
                userconfigs: response.data.userconfigs || {},
                supplierRules: response.data.supplierRules,
                vatCollectorCodes: response.data.vatCollectorCodes,
                onlineszamlaToken: response.data.onlineszamlaToken
            });

            document.body.classList.toggle('loading-body', false);
        });
    };

    nextStep = () => {
        this.setStep(this.state.currentStep + 1);
    };

    setStep = (step) => {
        this.setState({
            currentStep: step
        });
    };

    editRules = () => {
        this.setState({
            editrules: !this.state.editrules
        });
    };

    setData = (data) => {
        this.setState(data);
    };

    updateInvoices = (invoices, supplierRules) => {
        let self = this;
        let addRuleCount = 0;
        let removeRuleCount = 0;

        invoices.map(function (invoice, invoiceIndex) {
            invoice.items.map(function (invoiceItem) {
                let selectedRule = self.invoiceFindRule(invoice, invoiceItem, supplierRules);

                if (selectedRule) {
                    invoiceItem.main_bookkeeping_number = selectedRule.main_bookkeeping_number;
                    invoiceItem.vat_collector_id = selectedRule.vat_collector_id;
                    invoiceItem.vat_collector_title = selectedRule.vat_collector_id ? self.state.vatCollectorCodes.find(x => x.id === selectedRule.vat_collector_id).title : '';
                    invoiceItem.vat_degree = selectedRule.vat_degree;

                    if (invoiceItem.rule_id !== selectedRule.id) {
                        invoiceItem.rule_id = selectedRule.id;
                        addRuleCount++;
                    }
                } else if (invoiceItem.rule_id) {
                    invoiceItem.rule_id = null;
                    invoiceItem.main_bookkeeping_number = null;
                    invoiceItem.vat_collector_id = null;
                    invoiceItem.vat_collector_title = null;
                    invoiceItem.vat_degree = null;
                    removeRuleCount++;
                }
            });
        });

        return {
            addRuleCount: addRuleCount,
            removeRuleCount: removeRuleCount,
        };
    };

    invoiceFindRule(invoice, invoiceItem, supplierRules) {
        for (let ruleIndex in supplierRules) {
            if (this.invoiceCheckRule(invoice, invoiceItem, supplierRules[ruleIndex])) {
                return supplierRules[ruleIndex];

            }
        }
        return null;
    }

    invoiceCheckRule(invoice, invoiceItem, rule) {
        if (rule.supplier_name
            && invoice.supplier.name.toUpperCase() !== rule.supplier_name.toUpperCase()
        ) {
            return false;
        }
        if (rule.item_name
            && !invoiceItem.lineDescription.toUpperCase().includes(rule.item_name.toUpperCase())
        ) {
            return false;
        }
        if (rule.vat * 1 !== invoiceItem.vatPercentage * 100) {
            return false;
        }
        return true;
    }

    render() {
        return (
            <section id='supplier-upload'>
                {!this.state.editrules && !this.state.hidemenu
                    ? <div>
                        <HeaderSteps setStep={(step) => this.setStep(step)} currentStep={this.state.currentStep}/>
                        <div className='header'>
                            <div className='container'>

                                <h1 className='margin-bottom-50'>Onlineszamla rendszerből lekért tételek kontírozása és könyvelése</h1>

                                <p>
                                    Kérjük állítsa be az Online számla API kapcsolatát a bejövő számlákhoz,
                                    majd adja meg a kiválasztott cég főkönyvi struktúrájának megfelelő Főkönyvi számokat és állítsa be a könyvelni kívánt időszakot.
                                </p>

                                <div className="row" style={{marginBottom: "50px"}}>
                                    <div className="col-md-12">
                                        <div className="pull-left">
                                            <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : ''} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                                        </div>
                                        <div className="pull-right">
                                            {this.state.company
                                                ? <Link className={this.state.company.onlineszamlaToken ? 'table-green-btn' : 'table-gray-btn'} to={`/company/onlineszamla/${this.state.company.id}`}>Onlineszámla API</Link>
                                                : null
                                            }&nbsp;
                                            <a onClick={() => this.editRules()} className='table-green-btn'>Szabályok</a>&nbsp;
                                            <a href='/letoltesek/Beeker_Onlineszamla.pdf' className='table-green-btn' target='_blank'>Használati útmutató</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <div className={this.state.editrules ? '' : 'd-none'}>
                    <div className='container-fluid'>
                        <Rules
                            rerender={this.state.editrules}
                            company={this.state.company}
                            supplierRules={this.state.supplierRules}
                            vatCollectorCodes={this.state.vatCollectorCodes}
                            invoices={this.state.invoices}
                            company_id={this.state.company_id}
                            editRules={() => this.editRules()}
                            setData={(data) => this.setData(data)}
                            updateInvoices={(invoices, supplierRules) => this.updateInvoices(invoices, supplierRules)}
                        />
                    </div>
                </div>

                <div className={this.state.company && this.state.company.onlineszamlaToken ? 'd-none' : ''}>
                    <p className="text-center">
                        Jelenleg nincs beállítva az Onlineszamla API kapcsolat.<br/>
                        {this.state.company
                            ? <Link to={`/company/onlineszamla/${this.state.company.id}`} className='link-color'>Kattintson IDE a beállításhoz!</Link>
                            : null
                        }
                    </p>
                </div>
                {this.state.company
                    ? <div className={this.state.editrules || !this.state.company.onlineszamlaToken ? 'd-none' : 'upload-body'}>
                        <div className={this.state.currentStep === 1 ? '' : 'd-none'}>
                            <div className='container'>
                                <Upload {...this.props}
                                        company={this.state.company}
                                        vatCollectorCodes={this.state.vatCollectorCodes}
                                        userconfigs={this.state.userconfigs}
                                        supplierRules={this.state.supplierRules}
                                        invoices={this.state.invoices}
                                        setData={(data) => this.setData(data)}
                                        updateInvoices={(invoices, supplierRules) => this.updateInvoices(invoices, supplierRules)}
                                />
                            </div>
                        </div>
                        <div className={this.state.currentStep === 2 ? '' : 'd-none'}>
                            <div className='container-fluid'>
                                <Assignment
                                    {...this.props}
                                    company={this.state.company}
                                    vatCollectorCodes={this.state.vatCollectorCodes}
                                    invoices={this.state.invoices}
                                    supplierRules={this.state.supplierRules}
                                    nextStep={() => this.nextStep()}
                                    setData={(data) => this.setData(data)}
                                    updateInvoices={(invoices, supplierRules) => this.updateInvoices(invoices, supplierRules)}
                                />
                            </div>
                        </div>
                        <div className={this.state.currentStep === 3 ? '' : 'd-none'}>
                            <div className='container'>
                                <DownloadXml
                                    {...this.props}
                                    company={this.state.company}
                                    invoices={this.state.invoices}
                                    hideStepsMenu={() => this.hideStepsMenu()}
                                />
                            </div>
                        </div>
                    </div>
                    : null
                }

            </section>
        )
    }
}

export default Supplier


// WEBPACK FOOTER //
// ./src/components/supplier/supplier.js